import { useIntakeManagementPageProps, useApplication } from '~/data';
import { ProgramEditLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { useParams } from 'react-router-dom';
import { ProgramEditProvider } from './context/ProgramEditContext';

export function ProgramEditPage() {
  useWindowDocumentTitle('Change Primary Program Intake');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } =
    useIntakeManagementPageProps();

  const applicationId = useApplicationId();
  const { application, isLoadingApplication, applicationError, isApplicationError } = useApplication(applicationId);

  if ((!isInitialPropsError && isLoadingInitialProps) || (!isApplicationError && isLoadingApplication)) {
    return <LoadingPage />;
  }
  if (isInitialPropsError || isApplicationError) {
    return isInitialPropsError ? <ErrorHandler error={initialPropsError} /> : <ErrorHandler error={applicationError} />;
  }
  if (!initialProps || !application) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <ProgramEditProvider application={application} initialProps={initialProps}>
      <ProgramEditLayout />
    </ProgramEditProvider>
  );
}

function useApplicationId() {
  const { id } = useParams() as { id: string };
  return id;
}
